import React from 'react'
import { Row, Separator } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'

type Props = {
  separatorSize?: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'xxs' | 'nano' | 'hide'
  size?: 'xs' | 'sm' | 'md' | 'lg'
}

export default function CenteredLoadingSpinner({ size = 'lg', separatorSize = 'xxl' }: Props): JSX.Element {
  return (
    <div data-testid="spinner">
      <Separator size={separatorSize} />
      <Row alignX="center">
        <NoticeLoading size={size} />
      </Row>
      <Separator size={separatorSize} />
    </div>
  )
}
